import { get_axios_file_download_instance, get_axios_report_instance, get_axios_instance, api_new_report_variables, api_variables, errorHandler } from '@/apis/variables.js';
// import Vue from 'vue';
/*
Author: Vinod
Date: 24/01//2020
Issue Description: Monthly TDS Report.
search_string: PL_2410
*/
//change service name

/*
Author: Vinod
Date: 16/04/2020
Issue Description: Change in implementation to download reports for more than 100 employees.
search_string: PL_3064
*/
var axios_instance_salary_register = get_axios_instance(api_variables.SERVICE_REPORTS_SALARY_REGISTER); // PL_3064  //
var axios_instance_salary_report = get_axios_instance(api_variables.SERVICE_REPORTS_CUSTOM_SALARY_REPORT);
var axios_instance_payroll_summary = get_axios_instance(api_variables.SERVICE_REPORTS_PAYROLL_SUMMARY);
var axios_instance_bank_summary = get_axios_instance(api_variables.SERVICE_REPORTS_BANK_SUMMARY);
var axios_instance_lop = get_axios_instance(api_variables.SERVICE_REPORTS_LOP);
var axios_instance_ctc = get_axios_instance(api_variables.SERVICE_REPORTS_CTC);
var axios_instance_variance = get_axios_instance(api_variables.SERVICE_REPORTS_VARIANCE);
var axios_instance_jv = get_axios_instance(api_variables.SERVICE_REPORTS_JV);
var axios_instance_it_computation = get_axios_instance(api_variables.SERVICE_REPORTS_IT_COMPUTATION);
var axios_instance_process_download = get_axios_instance(api_variables.SERVICE_REPORTS_PROCESS_DOWNLOAD);
var axios_instance_hc = get_axios_instance(api_variables.SERVICE_REPORTS_HC);
var axios_instance_ba = get_axios_instance(api_variables.SERVICE_REPORTS_BA);
var axios_instance_bt = get_axios_instance(api_variables.SERVICE_REPORTS_BT);
var axios_instance_tds = get_axios_instance(api_variables.SERVICE_REPORTS_TDS); //PL_2410
var axios_instance_statutory = get_axios_instance(api_variables.SERVICE_REPORTS_STATUTORY);
var axios_filter = get_axios_instance(api_variables.SERVICE_REPORTS_FILTER);
var axios_instance_form16=get_axios_instance(api_variables.SERVICE_REPORTS_FORM16);
var axios_instance_employee_report = get_axios_instance(api_variables.SERVICE_REPORTS_EMPLOYEE);
var axios_instance_annual_salary_report = get_axios_instance(api_variables.SERVICE_ANNUAL_SALARY_REPORT);
var axios_instance_detailed_pf = get_axios_instance(api_variables.SERVICE_DETAILED_PF_REPORT);
var axios_instance_esi_report = get_axios_report_instance(api_new_report_variables.SERVICE_ESI_REPORT);
var axios_instance_pt_report = get_axios_instance(api_variables.SERVICE_PT_REPORT);
var axios_instance_lwf_report = get_axios_instance(api_variables.SERVICE_LWF_REPORT);


const state = {
    data: [],
    isFetching: false,
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

}
const actions = {
    async fetchAll({ commit }, payload) {
        try {
            let res = await axios_filter.post(`?page=${payload.page}`, { data: payload.obj });
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
    async downloadSalaryRegisterReport({ commit }, payload) {
        try {
            let res = await axios_instance_salary_register.post('', payload);
            // PL_3064
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "Salary_Register_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async downloadPayrollSummaryReport({ commit }, payload) {
        try {
            let res = await axios_instance_payroll_summary.post('', payload);
            // PL_3064
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "Payroll_Summary_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async downloadBankSummaryReport({ commit }, payload) {
        try {
            let res = await axios_instance_bank_summary.post('', payload);
            // PL_3064
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "Bank_Summary_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async downloadSalaryReport({ commit }, payload) {
        try {
            let res = await axios_instance_salary_report.post('/', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "Salary_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async downloadLOPReport({ commit }, payload) {
        try {
            let res = await axios_instance_lop.post('/', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "LOP_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadSalaryCTCReport({ commit }, payload) {
        try {
            let res = await axios_instance_ctc.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "CTC_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadVarianceReport({ commit }, payload) {
        try {
            let res = await axios_instance_variance.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "Variance_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadJVReport({ commit }, payload) {
        try {
            let res = await axios_instance_jv.post('', payload);
            // const res.data.payload = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "JV_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async downloadITComputationReport({ commit }, payload) {
        try {
            let res = await axios_instance_it_computation.get('', {
              params: {
                ...payload
              }
            });
            // const res.data.payload = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.Location;
                link.setAttribute("download", "IT_Computation_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async processDownloadReport({ commit }, payload) {
        try {
            let res = await axios_instance_process_download.get('', {
              params: {
                ...payload
              }
            });
            // const res.data.payload = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.Location;
                link.setAttribute("download", "IT_Computation_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async downloadform16Report({ commit }, payload) {
        //console.log("checking data before sending",payload);
        try {
            let res = await axios_instance_form16.get('', {
                params: {
                    empId:payload.empId,
                    financialYear:payload.financialYear
                  }
              });
            // const res.data.payload = window.URL.createObjectURL(new Blob([res.data]));
            //console.log('payload of form 16',res);
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.data[0].form16_file;
                link.setAttribute("download", res.data.payload.data[0].form16_file+".pdf"); //or any other extension
                link.setAttribute('target','_blank');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadHCReport({ commit }, payload) {
        try {
            let res = await axios_instance_hc.post('', {
                le_id : payload.data.le_id,
                financialYear : payload.data.financialYear,
                month : payload.data.month
            });
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "Head_Count_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadBAReport({ commit }, payload) {
        try {
            let res = await axios_instance_ba.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "Salary_Bank_Advise_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadBTReport({ commit }, payload) {
        try {
            let res = await axios_instance_bt.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "Bank_advise_transfer_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    // PL_2410
    async downloadTDSReport({ commit }, payload) {
        try {
            let res = await axios_instance_tds.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "TDS_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadStatutoryReports({ commit }, payload) {
        try {
            let res = await axios_instance_statutory.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", payload.data.report + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadEmployeeReports({ commit }, payload) {
        try {
            let res = await axios_instance_employee_report.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    }, 

    async downloadAnnualSalaryReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_annual_salary_report.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async downloadDetailedPfReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_detailed_pf.get('/',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadEsiReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_esi_report.get('',{
                params: {
                    ...payload
                }
            } );    
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadPtReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_pt_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadLwfReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_lwf_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

}

export default {
    namespaced: true,
    actions,
    mutations,
    state
};
